import { Component, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'a-icon-tooltip',
  templateUrl: './a-icon-tooltip.component.html',
  styles: [
    ":host{display:inline-block;}"
  ]
})
export class AIconTooltipComponent {

  @Input() icon: string;
  @Input() tpl: TemplateRef<any>;

  isOpen: boolean = false;



}
